import { render, staticRenderFns } from "./couponedList.vue?vue&type=template&id=3f13a133&scoped=true&"
import script from "./couponedList.vue?vue&type=script&lang=js&"
export * from "./couponedList.vue?vue&type=script&lang=js&"
import style0 from "./couponedList.vue?vue&type=style&index=0&id=3f13a133&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f13a133",
  null
  
)

export default component.exports